import classnames from "classnames";
import * as React from "react";

import { Button as MUIButton, WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

type ClassNames = "btn" | "contrastBtn" | "disabled";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    btn: {
        border: "1px solid black",
        textTransform: "none",
        boxShadow: "none",
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
        borderRadius: 5
    },
    contrastBtn: {
        border: "1px solid white",
        textTransform: "none",
        backgroundColor: "transparent",
        boxShadow: "none",
        color: "white",
        "&:hover": {
            color: theme.palette.primary[500],
            backgroundColor: "white !important"
        },
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
        borderRadius: 5
    },
    disabled: {
        opacity: 0.5
    }
});

interface ButtonProps {
    href?: string,
    target?: string,
    onClick?: (e: any) => void,
    type?: "submit",
    autoFocus?: boolean,
    disabled?: boolean,
    className?: string,
    style?: React.CSSProperties,

    color?: string,
    contrast?: boolean,
    primary?: boolean
}

class Button extends React.Component<WithStyles<ClassNames> & ButtonProps> {
    public render() {
        const {
            classes, color, href, target, onClick, contrast, type, primary, autoFocus, disabled, className, children,
            style: extraStyle
        } = this.props;
        const theme = this.props.theme as Theme;
        const style: React.CSSProperties = {
            ...extraStyle,
            backgroundColor: primary ? theme.palette.primary[500] : (color ? color : "transparent"),
            fontWeight: (primary || !!color) ? 300 : 400
        };
        if (primary || !!color) {
            style.borderColor = primary ? theme.palette.primary[500] : color;
            style.color = "white";
        }
        return (
            <MUIButton
                className={classnames(
                    disabled ? classes.disabled : "",
                    contrast ? classes.contrastBtn : classes.btn,
                    className
                )}
                {...{style, href, target, type, onClick, autoFocus, disabled}}
            >
                {children}
            </MUIButton>
        );
    }
}

export default withStyles(styles, { withTheme: true })<ButtonProps>(Button);



// WEBPACK FOOTER //
// ./src/components/Button.tsx